import { combineReducers } from '@reduxjs/toolkit';
import { reducer as organizationsReducer } from './model/organizations';
import { reducer as currentOrganizationReducer } from './model/setOrganization';

export * as OrganizationsModel from './model';
const organizationReducer = combineReducers({
  organizations: organizationsReducer,
  currentOrganization: currentOrganizationReducer,
});
export default organizationReducer;
